import { c as _c } from "react/compiler-runtime";
import { featureFlagAtom, FeatureFlagEnum } from '@states/featureFlagAtom';
import { useJotaiValue } from '@states/jotai/hooks';
export type TUseFeatureFlagsReturn = {
  isFeatureEnabled: (flag: FeatureFlagEnum) => boolean;
  isCmsBasedVerifyDetailsContentEnabled: boolean;
  isConsumerActivityLogEnabled: boolean;
  isConsumerAnchorSearchEnabled: boolean;
  isContractActionsEnabled: boolean;
  isContractActivityLogEnabled: boolean;
  isContractPdfLinkShown: boolean;
  isPayByBankEnabled: boolean;
  isTabSystemEnabled: boolean;
  isSavesEnabled: boolean;
  isTransactionActionsEnabled: boolean;
  isDeferredCallRedirectEnabled: boolean;
  isTrainingEnabled: boolean;
  isNewPermissionSystemEnabled: boolean;
  isPostDateOnMissingDownPaymentEnabled: boolean;
  isCustomerOwnsVehicleEnabled: boolean;
  isStopTransferEnabled: boolean;
  isConsumerPageRedesignEnabled: boolean;
  isNotesV2Enabled: boolean;
  isDarkModeToggleEnabled: boolean;
};
export function useFeatureFlags() {
  const $ = _c(60);
  const {
    featureFlags
  } = useJotaiValue(featureFlagAtom);
  let t0;
  let t1;
  if ($[0] !== featureFlags) {
    t0 = flag => featureFlags.includes(flag);
    t1 = featureFlags.includes(FeatureFlagEnum.CmsBasedVerifyDetailsContent);
    $[0] = featureFlags;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== featureFlags) {
    t2 = featureFlags.includes(FeatureFlagEnum.ConsumerActivityLog);
    $[3] = featureFlags;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== featureFlags) {
    t3 = featureFlags.includes(FeatureFlagEnum.ContractActions);
    $[5] = featureFlags;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== featureFlags) {
    t4 = featureFlags.includes(FeatureFlagEnum.ContractActivityLog);
    $[7] = featureFlags;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== featureFlags) {
    t5 = featureFlags.includes(FeatureFlagEnum.ContractPdf);
    $[9] = featureFlags;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== featureFlags) {
    t6 = featureFlags.includes(FeatureFlagEnum.ConsumerAnchorSearch);
    $[11] = featureFlags;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== featureFlags) {
    t7 = featureFlags.includes(FeatureFlagEnum.PayByBank);
    $[13] = featureFlags;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== featureFlags) {
    t8 = featureFlags.includes(FeatureFlagEnum.TabSystem);
    $[15] = featureFlags;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== featureFlags) {
    t9 = featureFlags.includes(FeatureFlagEnum.Saves);
    $[17] = featureFlags;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== featureFlags) {
    t10 = featureFlags.includes(FeatureFlagEnum.TransactionActions);
    $[19] = featureFlags;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== featureFlags) {
    t11 = featureFlags.includes(FeatureFlagEnum.DeferredCallRedirect);
    $[21] = featureFlags;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== featureFlags) {
    t12 = featureFlags.includes(FeatureFlagEnum.Training);
    $[23] = featureFlags;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== featureFlags) {
    t13 = featureFlags.includes(FeatureFlagEnum.NewPermissionSystem);
    $[25] = featureFlags;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== featureFlags) {
    t14 = featureFlags.includes(FeatureFlagEnum.PostDateOnMissingDownPayment);
    $[27] = featureFlags;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== featureFlags) {
    t15 = featureFlags.includes(FeatureFlagEnum.CustomerOwnsVehicle);
    $[29] = featureFlags;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== featureFlags) {
    t16 = featureFlags.includes(FeatureFlagEnum.StopTransfer);
    $[31] = featureFlags;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== featureFlags) {
    t17 = featureFlags.includes(FeatureFlagEnum.ConsumerPageRedesign);
    $[33] = featureFlags;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== featureFlags) {
    t18 = featureFlags.includes(FeatureFlagEnum.NotesV2);
    $[35] = featureFlags;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== featureFlags) {
    t19 = featureFlags.includes(FeatureFlagEnum.DarkModeToggle);
    $[37] = featureFlags;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t0 || $[40] !== t1 || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t2 || $[52] !== t3 || $[53] !== t4 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8 || $[58] !== t9) {
    t20 = {
      isFeatureEnabled: t0,
      isCmsBasedVerifyDetailsContentEnabled: t1,
      isConsumerActivityLogEnabled: t2,
      isContractActionsEnabled: t3,
      isContractActivityLogEnabled: t4,
      isContractPdfLinkShown: t5,
      isConsumerAnchorSearchEnabled: t6,
      isPayByBankEnabled: t7,
      isTabSystemEnabled: t8,
      isSavesEnabled: t9,
      isTransactionActionsEnabled: t10,
      isDeferredCallRedirectEnabled: t11,
      isTrainingEnabled: t12,
      isNewPermissionSystemEnabled: t13,
      isPostDateOnMissingDownPaymentEnabled: t14,
      isCustomerOwnsVehicleEnabled: t15,
      isStopTransferEnabled: t16,
      isConsumerPageRedesignEnabled: t17,
      isNotesV2Enabled: t18,
      isDarkModeToggleEnabled: t19
    };
    $[39] = t0;
    $[40] = t1;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t2;
    $[52] = t3;
    $[53] = t4;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  return t20;
}